import AutoAddress from '../AutoAddress/AutoAddress'
import StoreCheckout from 'GlobalStores/Checkout/StoreCheckout'
import { callOnChangeOrSetCheckout } from './fieldHelpers'

const renderAutoAddressField = ({ item, onChange }) => (
    <AutoAddress
        key={item.key}
        item={item}
        selectedAddressCallback={value => {
            if (onChange) {
                onChange(item, value)
            } else {
                StoreCheckout.CheckOutInstance().MapAutoAddressToForm(StoreCheckout.GetShippingForm(), value)
                StoreCheckout.CheckOutInstance().MapAutoAddressToForm(StoreCheckout.GetCheckoutForms(), value)
            }
        }}
        itemKeys={StoreCheckout.CheckOutInstance().AutoAddressDisplayKeys()}
        inputCallback={value => {
            callOnChangeOrSetCheckout(item, value, onChange)
        }}
    />
)

export default renderAutoAddressField

